import gql from 'graphql-tag';
import { AgentFragment } from '@/graphql/fragments';

export default gql`
  query agentByIdQuery($id: ID!) {
    agentById(id: $id) {
      __typename
      ...AgentFragment
    }
  }
  ${AgentFragment}
`;
